import { ref, onMounted, createApp, nextTick } from 'vue';
import common from '@page/common/js/common';
import $ from 'jquery';
import validate from '@global/vendors/jquery.validate.min';

import useAlert from '@global/composable/useAlert';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import AlertDialog from '@global/components/common/alert/AlertDialog.vue';

import {
  fireRegisterEvent,
  fireRegisterGTMEventByLINE,
  fireRegisterGTMEventByFB,
} from '@global/gtm/login/register';

import {
  fireLoginEvent,
  fireLoginGTMEventByLINE,
  fireLoginGTMEventByFB,
} from '@global/gtm/login/login';

const { postForgetPS, getAccountExist } = useAxiosAPI();
const { alertDialog } = useAlert();

const app = createApp({
  components: {
    AlertDialog,
  },
  setup() {
    const showPs = ref(false);

    function activePs(val) {
      showPs.value = val;
      nextTick(() => {
        if (val) {
          $('#forgotAccount').focus();
        }
      });
    }

    function fbLogin(event) {
      if ($(event.target).parents('.login__login').length > 0) {
        fireLoginGTMEventByFB();
      } else {
        fireRegisterGTMEventByFB();
      }
    }

    function lineLogin(event) {
      if ($(event.target).parents('.login__login').length > 0) {
        fireLoginGTMEventByLINE();
      } else {
        fireRegisterGTMEventByLINE();
      }
    }

    onMounted(() => {
      $.validator.addMethod(
        'regx',
        (value, element, regexpr) => {
          return regexpr.test(value);
        },
        'invalid format.',
      );

      $('#form-user-login').validate({
        errorClass: 'text-danger',
        errorElement: 'div',
        rules: {
          account: 'required',
          password: 'required',
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          form.submit();
          fireLoginEvent();
        },
      });

      $('#form-register').validate({
        errorClass: 'text-danger',
        errorElement: 'div',
        rules: {
          account: {
            required: true,
            email: true,
          },
          password: {
            required: true,
            regx: /^(?=.*\d)(?=.*[A-Za-z])[^\s]{6,15}$/,
          },
          checkpassword: {
            required: true,
            equalTo: '#registerPwd',
          },
        },
        messages: {
          checkpassword: {
            equalTo: 'The passwords entered are not the same.',
          },
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          const $btn = $(form).find("input[type='submit']");
          $btn.addClass('disabled');

          getAccountExist({
            params: {
              Account: $(form).find('input[name="account"]').val(),
            },
          })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  alertDialog.alert(res.data.Message);
                } else {
                  form.submit();
                  fireRegisterEvent();
                }
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              $btn.removeClass('disabled');
            });

          return false;
        },
      });

      $('#form-user-forgot').validate({
        errorClass: 'text-danger',
        errorElement: 'div',
        rules: {
          account: {
            required: true,
          },
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          const $btn = $(form).find("input[type='submit']");
          $btn.addClass('disabled');

          postForgetPS({
            Account: $(form).find('input[name="account"]').val(),
          })
            .then((res) => {
              if (res.data.Code === 200) {
                alertDialog.alert(res.data.Message);
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              $btn.removeClass('disabled');
            });
        },
      });
    });

    return {
      showPs,
      activePs,
      fbLogin,
      lineLogin,
    };
  },
});

app.mount('#app-login');
